import {useMutation} from '@tanstack/react-query';

import {apiClient} from '../../../../../utils/api-client';

import {useShareQuerySettingsCache} from './use-share-query-settings';

interface MutationParams {
    queryId: number;
    onlyOwnerCanShare: boolean;
}

interface MutationContext {
    onlyOwnerCanShare: boolean;
}

function changeShareQuerySettingsRequest({queryId, onlyOwnerCanShare}: MutationParams) {
    return apiClient.put({
        path: `queries-service/api/queries/${queryId}/share-settings`,
        parameters: {
            onlyOwnerCanShare
        }
    });
}

export function useShareQuerySettingsMutation(queryId: number) {
    const {setOnlyOwnerCanShare} = useShareQuerySettingsCache(queryId);

    return useMutation<unknown, Error, MutationParams, MutationContext>({
        mutationFn: changeShareQuerySettingsRequest,
        onMutate: async (params) => {
            // Optimistically update and capture the previous value
            const previous = await setOnlyOwnerCanShare(params.onlyOwnerCanShare);
            // Return a plain boolean for the context (not a Promise)
            return {onlyOwnerCanShare: previous?.onlyOwnerCanShare ?? params.onlyOwnerCanShare};
        },
        onError: async (_error, _params, context) => {
            if (context) {
                // Roll back to the previous value on error
                await setOnlyOwnerCanShare(context.onlyOwnerCanShare);
            }
        }
    });
}
